module.exports = __webpack_public_path__ + "img/ass_pack.231d27af.png";